/**********************************************
inRiver.ImageMap
   Version: 1.0.0 (2015-06-22)

Copyright 2015 inRiver AB

http://www.inriver.com

Dependencies:   jquery.imagemapster v1.2.10 
                jquery v2.0.3 min

***********************************************/
if (typeof window.define === "function" && window.define.amd) {
    window.define("inRiverImageMap", [], function () {
        return window.InRiverImageMap;
    });
}

window.InRiverImageMap = {
    _imageMapOptions: [],
    imageEl: "",
    options: {},
    HoverCoords: 0,
    initImageMap: function (imageEl, options) {
        window.InRiverImageMap.imageEl = imageEl;
        window.InRiverImageMap.options = options;
        var that = this;
        var timers = 0;
        var update = true;
        var globalImages = [];
        //console.log("options from inriver",options);

        imageEl.attr("inriver-id", options.imageMapData.id);
        InRiverImageMap._imageMapOptions[options.imageMapData.id] = options;
        options.keepAreasHighLighted = options.keepAreasHighLighted || false;

        // Create image map element if it doesn't exist already
        var imageMapName = "map-" + options.imageMapData.id;
        var mapEl = $("map[name^=" + imageMapName + "]");
        if (mapEl.length == 0) {
            // Insert image map to DOM
            mapEl = $("<map name='" + imageMapName + "'></map>");
            mapEl.insertAfter(imageEl);
            imageEl.attr("usemap", "#" + imageMapName);
        }

        // InRiver ImageMap options
        var imageWidth = options.imageWidth || imageEl.width();
        var imageHeight = options.imageHeight || imageEl.height();
        var spotSize = options.spotSize || 20;
        var spotImageUrl = options.spotImageUrl || null;
        var spotBackgroundColor = options.spotBackgroundColor || "#333";
        var spotForegroundColor = options.spotForegroundColor || "#fff";
        var disableSpotRendering = options.disableSpotRendering || false; // If true, spots will be treated as areas
        var spotsLoaded = false;

        var globalSpots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);

        window.InRiverImageMap.initialCounter = 0;
        window.InRiverImageMap.initialCounter2 = 0;

        if (!spotImageUrl) {
            spotSize = 10;
        } else {
            spotSize = spotSize * 0.8;
        }
        // Create image map areas
        this.createAreasFromData(options.imageMapData.id, imageWidth, imageHeight, spotSize);

        // The dummy area is invisible and can be useful when managing complex highlight logics (workaround for limitations in image mapster)
        if (options.useDummyArea) {
            var dummyAreaEl = $("<area/>", {
                key: options.imageMapData.id + "-dummy",
                shape: "circle",
                coords: "-10000,-10000,0",
                href: "#"
            });
            mapEl.append(dummyAreaEl);
        }

        var imageMapsterOptions = options.imageMapsterOptions || {};

        // Image mapster default values (only set if they are not supplied)
        imageMapsterOptions.isSelectable = imageMapsterOptions.isSelectable || false;
        imageMapsterOptions.mapKey = imageMapsterOptions.mapKey || "key";
        imageMapsterOptions.fillOpacity = imageMapsterOptions.fillOpacity || 0.5;
        imageMapsterOptions.fillColor = imageMapsterOptions.fillColor || "999999";
        imageMapsterOptions.stroke = imageMapsterOptions.stroke || true;
        imageMapsterOptions.strokeColor = imageMapsterOptions.strokeColor || "ffffff";
        imageMapsterOptions.strokeOpacity = imageMapsterOptions.strokeOpacity || 0.9;
        imageMapsterOptions.strokeWidth = imageMapsterOptions.strokeWidth || 1;
        imageMapsterOptions.scaleMap = imageMapsterOptions.scaleMap || false;
        //imageMapsterOptions.scaleMap = true




        $.extend(imageMapsterOptions, {
            onConfigured: function () {
                var canvas = imageEl.siblings("canvas")[0];
                var context = canvas.getContext('2d');
                //context.imageSmoothingEnabled = true;

                var iniRippleCounter = 0;
                var iniCounter2 = 0;

                function resetAnimation() {
                    if (isExplodedDiagram || isHotSpotExplodedDiagram) {
                    
                    } else if (!spotImageUrl) {
                        context.clearRect(0, 0, canvas.width, canvas.height);

                        var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas,
                            imageWidth,
                            imageHeight);
                        $.each(spots,
                            function (ix, spot) {


                                //inner circle
                                for (var i = 1; i < 7; i++) {
                                    context.beginPath();
                                    context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                    context.strokeStyle = spotBackgroundColor;
                                    context.strokeWidth = 10;
                                    context.lineWidth = 2;
                                    context.stroke();
                                }
                            });
                    }
                    else {
                        context.clearRect(0, 0, canvas.width, canvas.height);

                        $.each(spots, function (ix, spot) {
                            var image = options.linkedEntities[ix].iconPicture;
                            var baseImage = new Image();
                            baseImage.src = image;

                            baseImage.onload = function () {
                                context.drawImage(baseImage,
                                    Math.round(spot.x) - spotRadius,
                                    Math.round(spot.y) - spotRadius,
                                    spotRadius * 2,
                                    spotRadius * 2);
                            };
                        });
                    }
                }

                var tmp = 1;

                function iniRipple() {
                    setTimeout(function () {

                        rippler(tmp, tmp);
                        tmp++;
                        if (tmp < 17) {
                            iniRipple();
                        }
                        else {
                            resetAnimation();
                            timers = 0;
                        }
                    },
                        70);
                }

                function rippler(innerLooper1, innerLooper2) {
                    if (!spotImageUrl) {
                        context.clearRect(0, 0, canvas.width, canvas.height);

                        var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas,
                            imageWidth,
                            imageHeight);
                        $.each(spots,
                            function (ix, spot) {
                                var local1 = innerLooper1;
                                var local2 = innerLooper2;
                                //inner circle
                                for (var i = 1; i < 7; i++) {
                                    context.beginPath();
                                    context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                    context.strokeStyle = spotBackgroundColor;
                                    context.strokeWidth = 10;
                                    context.lineWidth = 2;
                                    context.stroke();
                                }

                                //background circle rippling
                                if (local1 < 15) {
                                    for (var temp = 1; temp < local1; temp++) {
                                        context.beginPath();
                                        context.arc(spot.x, spot.y, 7 + temp, 0, 2 * Math.PI);
                                        //var opacity = 1 / Math.sqrt(local1);
                                        context.strokeStyle = "rgba(255, 140, 58," + (0.8 - temp / 20) + ")";
                                        context.closePath();
                                        context.stroke();
                                    }
                                }
                                local1++;
                                return;
                            });
                    }
                }
                function intervalRippler() {
                    if (!spotImageUrl) {
                        context.clearRect(0, 0, canvas.width, canvas.height);

                        var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas,
                            imageWidth,
                            imageHeight);
                        $.each(spots,
                            function (ix, spot) {
                                var local1 = 1;
                                //inner circle
                                for (var i = 1; i < 7; i++) {
                                    context.beginPath();
                                    context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                    context.strokeStyle = spotBackgroundColor;
                                    context.strokeWidth = 10;
                                    context.lineWidth = 2;
                                    context.stroke();
                                }

                                //background circle rippling
                                if (local1 < 12) {
                                    for (var temp = 1; temp < local1; temp++) {
                                        context.beginPath();
                                        context.arc(spot.x, spot.y, 7 + temp, 0, 2 * Math.PI);
                                        //var opacity = 1 / Math.sqrt(local1);
                                        context.strokeStyle = "rgba(255, 140, 58," + (0.5 - temp / 20) + " )";
                                        context.closePath();
                                        context.stroke();
                                    }
                                }
                                //second rippling circle
                                local1++;
                                return;
                            });
                    }
                }

                // Render spots
                if (!disableSpotRendering) {
                    var spotRadius = Math.round(spotSize);

                    if (spotImageUrl) {
                        if (!spotsLoaded) {
                            //Make the images a lil bit smaller according to ticket
                            //spotRadius = spotRadius * 0.762;
                            var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);
                            if (globalImages.length == 0) {
                                $.each(spots, function (ix, spot) {
                                    var image = options.linkedEntities[ix].iconPicture;
                                    var baseImage = new Image();
                                    baseImage.src = image;

                                    globalImages[ix] = baseImage;

                                    //add onload to global scope
                                    globalImages.onload = function () {
                                        context.drawImage(globalImages[ix],
                                            Math.round(spot.x) - spotRadius,
                                            Math.round(spot.y) - spotRadius,
                                            spotRadius * 2,
                                            spotRadius * 2);
                                    };
                                    //initial drawing needed for some reason
                                    baseImage.onload = function () {
                                        context.drawImage(baseImage,
                                            Math.round(spot.x) - spotRadius,
                                            Math.round(spot.y) - spotRadius,
                                            spotRadius * 2,
                                            spotRadius * 2);
                                    };
                                });
                                spotsLoaded = true;
                            }
                        }
                    } else {
                        var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);
                        //Special for exploded, just one out circle
                        if (isExplodedDiagram || isHotSpotExplodedDiagram) {
                            context.clearRect(0, 0, canvas.width, canvas.height);

                            $.each(spots, function (ix, spot) {

                                //inner circle
                                for (var i = 1; i < 7; i++) {
                                    context.beginPath();
                                    context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                    context.strokeStyle = "rgba(255, 140, 58, 0.4)";
                                    //context.strokeStyle = "rgba(255, 255, 255, 0)";
                                    context.strokeWidth = 10;
                                    context.lineWidth = 2;
                                    context.stroke();
                                }
                            });
                            return;
                        } else {
                        //Set timeout and ripple once

                        timers = setInterval(function () {
                            tmp = 1;
                            iniRipple();
                        }, 3000);
                        }

                        context.clearRect(0, 0, canvas.width, canvas.height);

                        $.each(spots, function (ix, spot) {

                            //inner circle
                            for (var i = 1; i < 7; i++) {
                                context.beginPath();
                                context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                context.strokeStyle = spotBackgroundColor;
                                context.strokeWidth = 10;
                                context.lineWidth = 2;
                                context.stroke();
                            }

                        });
                    }
                }

                // Callback when finished setup
                if (options.onConfigured) {
                    options.onConfigured();
                }
            },
            onClick: function (area) {
                var imageMapId = window.InRiverImageMap.getImageMapIdFromArea(area);
                var imageMapOptions = window.InRiverImageMap._imageMapOptions[imageMapId];

                if (options.systemType == "ExplodedChart") {
                    var isExplodedDiagram = true;
                }

                if (options.systemType == "HotSpotExplodedChart") {
                    var isHotSpotExplodedDiagram = true;
                }

                if (isExplodedDiagram || isHotSpotExplodedDiagram) {
                    if (imageMapOptions.onClick) {

                        var ecom;
                        var priceindex;

                        if (isHotSpotExplodedDiagram) {
                            imageMapOptions.onClick(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].entities[0]), area.e, window.InRiverImageMap.getAreaIndexFromArea(area));
                            ecomId = imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].entities[0].entityId;
                            priceIndex = imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].entities[0].index;
                        } else {
                            imageMapOptions.onClick(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)]), area.e);
                            ecomId = imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].entityId;
                            priceIndex = imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].index;
                        }
                       
                        

                        //TODO add ecom stuff
                        if (isExplodedDiagram) {
                            var priceItem = imageMapOptions.linkedEntities[priceIndex]

                            $("#code option").val(ecomId);
                            var addToCartButton = $('.js-exploaded-add-to-cart');
                            var priceSpan = $('#price-span');
                            var excludingVat = $('.excluding-vat-text');
                            var quoteTextLabel = priceSpan.data('quotetext');
                            var quoteAndBuyButtonContainer = $('.js-buy-buttons-section');
                            
                            var quantity = $('.js-exploded-modal-right-col #quantityQ');
                            var quantityNotQuoteable = $('.js-quantity-not-quotable');
                            var quantityVal = priceItem.quantity;

                            if (quantityVal == 0) {
                                quantityVal = 1;
                                $('.js-quantity-info-icon').hide();
                            }
                            
                            $('.js-quantity-value').text(quantityVal);

                            if (!priceItem.itemIsNotQuotableNotSellable) {
                                quoteAndBuyButtonContainer.removeClass('hidden');
                                quantityNotQuoteable.addClass('hidden');
                                $('.js-exploded-price').removeClass('hidden'); 

                                if (quantity) {

                                    quantity.val(quantityVal);
                                    quantity.attr("data-quantity", quantityVal);
                                }
                                if (priceItem.price != null) {
                                    addToCartButton.show();
                                    priceSpan.text(priceItem.price.unitPrice.amount + " " + priceItem.price.unitPrice.currency);
                                    priceSpan.show();
                                    excludingVat.show();

                                } else {
                                    priceSpan.text(quoteTextLabel);
                                    priceSpan.addClass('normal-text');
                                    excludingVat.hide();
                                    addToCartButton.hide();
                                }
                            }
                            else { 
                                quoteAndBuyButtonContainer.addClass('hidden');
                                excludingVat.hide();
                                addToCartButton.hide();
                                quantityNotQuoteable.text(': ' + quantityVal);
                                quantityNotQuoteable.removeClass('hidden'); 
                                $('.js-exploded-price').addClass('hidden'); 
                            }

                        }

                    }
                } else if (imageMapOptions.onClick) {
                    imageMapOptions.onClick(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)]), area.e);
                }

            },
            onMouseover: function (area) {
                var spotRadius = Math.round(spotSize);

                var canvas = imageEl.siblings("canvas")[0];
                var context = canvas.getContext('2d');

                var element = $("[key=" + area.key + "]");
                var coords = (element.attr("coords").split(','));
                var x = coords[0];
                var y = coords[1];

                var yExtra = parseInt(y) + 25;

                //if (!spotImageUrl) {
                if (isHotSpotExplodedDiagram) {
                    $('.flowchart-teaser').css({ 'top': parseInt(y) + 'px', 'position': 'absolute', 'transform': 'translateX(-50%)', 'left': x + 'px' });
                } else {
                    $('.flowchart-teaser').css({ 'top': yExtra + 'px', 'position': 'absolute', 'transform':'translateX(-50%)', 'left': x + 'px' });
                }

                //}


                var imageMapId = window.InRiverImageMap.getImageMapIdFromArea(area);
                var imageMapOptions = window.InRiverImageMap._imageMapOptions[imageMapId];
                if (imageMapOptions.onMouseOver) {

                   
                    
                    if (isHotSpotExplodedDiagram) {
                        imageMapOptions.onMouseOver(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].entities[0]), area.e, x, spotSize, window.InRiverImageMap.getAreaIndexFromArea(area));
                        //imageMapOptions.onClick(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)].entities[0]), area.e, window.InRiverImageMap.getAreaIndexFromArea(area));

                    } else {
                        imageMapOptions.onMouseOver(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)]), area.e);
                    }
                   
                }

                var l = 0;
                var j = 0;
                var k = 0;

                //var timers;
                function resetAnimation() {
                    if (update) { // only draw if needed
                        update = false;

                        if (!spotImageUrl) {
                            context.clearRect(0, 0, canvas.width, canvas.height);

                            var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas,
                                imageWidth,
                                imageHeight);
                            $.each(spots,
                                function (ix, spot) {


                                    //inner circle
                                    for (var i = 1; i < 7; i++) {
                                        context.beginPath();
                                        context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                        context.strokeStyle = spotBackgroundColor;
                                        context.strokeWidth = 10;
                                        context.lineWidth = 2;
                                        context.stroke();
                                    }

                                });
                        } else {
                            context.clearRect(0, 0, canvas.width, canvas.height);

                            var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);

                            $.each(spots, function (ix, spot) {
                                context.drawImage(globalImages[ix],
                                    Math.round(spot.x) - spotRadius,
                                    Math.round(spot.y) - spotRadius,
                                    spotRadius * 2,
                                    spotRadius * 2);
                            });
                        }
                    }
                    requestAnimationFrame(resetAnimation);
                }
                function animate() {
                    //check if flowchart or system
                    //if (options.systemType == "ExplodedChart") {
                    //    console.log("exploded");
                    //    return;
                    //}
                    if (!spotImageUrl) {
                        return;
                        context.clearRect(0, 0, canvas.width, canvas.height);

                        var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas,
                            imageWidth,
                            imageHeight);
                        $.each(spots,
                            function (ix, spot) {
                                if (isExplodedDiagram || isHotSpotExplodedDiagram) {
                                    return;
                                }

                                //inner circle
                                for (var i = 1; i < 7; i++) {
                                    context.beginPath();
                                    context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                                    context.strokeStyle = spotBackgroundColor;
                                    context.strokeWidth = 10;
                                    context.lineWidth = 2;
                                    context.stroke();
                                }

                                if (x == Math.trunc(spot.x) && y == Math.trunc(spot.y)) {
                                    //small outer circle rippling
                                    for (var opacCirc = 1; opacCirc < 12; opacCirc++) {
                                        //if (j < 12) {
                                        context.beginPath();
                                        context.arc(spot.x, spot.y, 7 + opacCirc, 0, 2 * Math.PI);
                                        //var opacity = 1 / Math.sqrt(j);
                                        context.strokeStyle = "rgba(255, 140, 58," + 0.3 + " )";
                                        context.closePath();
                                        context.stroke();
                                    }

                                    if (j > 4) {
                                        //context.beginPath();
                                        //context.arc(spot.x, spot.y, spotRadius + l + 5, 0, 2 * Math.PI);
                                        //var opacity2 = 1 / Math.sqrt(l);

                                        //context.strokeStyle = "rgba(255, 140, 58," + opacity2 + " )";
                                        //context.closePath();
                                        //context.stroke();
                                        l++;
                                    }
                                    //static small circle

                                    //context.beginPath();
                                    //context.arc(spot.x, spot.y, spotRadius + 5, 0, 2 * Math.PI);
                                    //context.strokeStyle = spotBackgroundColor;
                                    //context.closePath();
                                    //context.stroke();

                                    j++;
                                    var slowdownEffect = 1 + j * 0.1;
                                    if (j < 16) {
                                        timers = setTimeout(animate, 80 + slowdownEffect);
                                    } else if (j == 16) {
                                        timers = 0;
                                        update = true;
                                        requestAnimationFrame(resetAnimation);
                                    } else {
                                        requestAnimationFrame(resetAnimation);
                                    }
                                } else {
                                    //small outer circle, non hovered

                                    //context.beginPath();
                                    //context.arc(spot.x, spot.y, spotRadius + 5, 0, 2 * Math.PI);
                                    //context.strokeStyle = spotBackgroundColor;
                                    //context.closePath();
                                    //context.stroke();
                                }

                            });
                    } else {
                        //is spot image - make it grow
                        context.clearRect(0, 0, canvas.width, canvas.height);
                        // Make the images a lil bit smaller according to ticket

                        //   TODO: Fix so animation is working  without flickering
                        var growingRadius = spotRadius + k / 2;

                        var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);
                        $.each(spots, function (ix, spot) {

                            context.drawImage(globalImages[ix],
                                Math.round(spot.x) - spotRadius,
                                Math.round(spot.y) - spotRadius,
                                spotRadius * 2,
                                spotRadius * 2);

                            if (x == Math.trunc(spot.x) && y == Math.trunc(spot.y)) {

                                //inner circle
                                for (var i = 1; i < k * 2; i++) {
                                    context.beginPath();
                                    context.arc(spot.x, spot.y, i + 15, 0, 2 * Math.PI, false);
                                    context.strokeStyle = "rgba(255, 255, 255," + 1 * (1 / k) + " )";
                                    context.strokeWidth = 10;
                                    context.lineWidth = 2;
                                    context.stroke();
                                }

                                k++;
                                if (k < 10) {
                                    timers = setTimeout(animate, 50);
                                }
                                else if (k == 10) {
                                    timers = 0;
                                    update = true;
                                    requestAnimationFrame(resetAnimation);
                                } else {
                                    requestAnimationFrame(resetAnimation);
                                }
                            }
                        });
                    }
                }
                if (timers > 0) {
                    return;
                }
                animate();

                //window.InRiverImageMap.initImageMap(window.InRiverImageMap.imageEl, window.InRiverImageMap.options);
                // Workaround of an imagemapster problem regarding highlighting
                //$('img').mapster('highlight', false);
                //$('img').mapster('highlight', area.key);




            },
            onMouseout: function (area) {
                $('.flowchart-teaser').css({ 'top': '10px', 'position': 'absolute', 'left': '10px', 'transform':'translateX(0)' });

                var imageMapId = window.InRiverImageMap.getImageMapIdFromArea(area);
                var imageMapOptions = window.InRiverImageMap._imageMapOptions[imageMapId];
                if (imageMapOptions.onMouseOut) {
                    imageMapOptions.onMouseOut(window.InRiverImageMap.createEventDataForArea(imageMapOptions.imageMapData.areas[window.InRiverImageMap.getAreaIndexFromArea(area)]), area.e);
                }
                if (imageMapOptions.keepAreasHighLighted) window.InRiverImageMap.highlightAllAreas(imageMapId);
            }
        });

        // Determine how spots will be rendered from an image mapster perspective
        if (!disableSpotRendering) {
            imageMapsterOptions.areas = imageMapsterOptions.areas || this.createImageMapsterAreaOptions(options.imageMapData);
        }

        imageEl.mapster(imageMapsterOptions);

        if (options.keepAreasHighLighted) this.highlightAllAreas(options.imageMapData.id);


        var zoomingStarted = false;
        if (!zoomingStarted) {

            if (imageEl.width() > 1100 ){
                console.log("too big initial image")
                imageEl.mapster('resize', 1100, 0, 0);
            };
            if (imageEl.height() > 1100){
                //imageEl.mapster('resize', 1100, 0, 0);
            };

        }
      

        var zoomlevel = imageEl.width();

        /////////////////ZOOOM STUFF///////////////////
        $('#zoomin').bind('click', function () {
            zoomingStarted = true;
            zoomlevel += 100;
            imageEl.mapster('resize', zoomlevel, 0, 100);

            //spotting

            setTimeout(function () {
                imageWidth = imageEl.width();
                imageHeight = imageEl.height();
                var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);
                //Special for exploded, just one out circle

                var canvas = imageEl.siblings("canvas")[0];
                var context = canvas.getContext('2d');


                context.clearRect(0, 0, canvas.width, canvas.height);

                $.each(spots, function (ix, spot) {

                    //inner circle
                    for (var i = 1; i < 7; i++) {
                        context.beginPath();
                        context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                        context.strokeStyle = "rgba(255, 140, 58, 0.4)";
                        //context.strokeStyle = "rgba(255, 255, 255, 0)";
                        context.strokeWidth = 10;
                        context.lineWidth = 2;
                        context.stroke();
                    }

                });
                return;


            }, 1000);
        });
        $('#zoomut').bind('click', function () {
            zoomingStarted = true;

            zoomlevel += -100;
            imageEl.mapster('resize', zoomlevel, 0, 100);
            //spotting
            setTimeout(function () {
                imageWidth = imageEl.width();
                imageHeight = imageEl.height();
                var spots = that.calculateAbsoluteSpotCoords(options.imageMapData.areas, imageWidth, imageHeight);
                //Special for exploded, just one out circle

                var canvas = imageEl.siblings("canvas")[0];
                var context = canvas.getContext('2d');


                context.clearRect(0, 0, canvas.width, canvas.height);

                $.each(spots, function (ix, spot) {

                    //inner circle
                    for (var i = 1; i < 7; i++) {
                        context.beginPath();
                        context.arc(spot.x, spot.y, i, 0, 2 * Math.PI, false);
                        context.strokeStyle = "rgba(255, 140, 58, 0.4)";
                        //context.strokeStyle = "rgba(255, 255, 255, 0)";
                        context.strokeWidth = 10;
                        context.lineWidth = 2;
                        context.stroke();
                    }

                });
                return;
            }, 1000);

        });

    },
    removeImageMap: function (imageEl) {
        // Restore the image element (if image map isn't initiated, do nothing)
        var id = imageEl.attr("inriver-id");
        if (id) {
            imageEl.removeAttr("inriver-id");

            // Remove options
            InRiverImageMap._imageMapOptions.splice($.inArray(InRiverImageMap._imageMapOptions[id], InRiverImageMap._imageMapOptions), 1);

            // Unbind image mapster
            imageEl.mapster("unbind");

            // Remove image map element
            var imageMapName = "map-" + id;
            var mapEl = $("map[name^=" + imageMapName + "]");
            mapEl.remove();
        }
    },
    createEventDataForArea: function (areaData) {
        // Create object that will be sent to the callback function
        var r = {};
        r.index = areaData.index;

        if (areaData.entityId) {
            r.entityId = areaData.entityId;
        }
        return r;
    },
    calculateAbsoluteSpotCoords: function (areas, imageWidth, imageHeight) {
        var spotCoords = [];
        var spots = $.grep(areas, function (area) {
            return area.type == "spot";
        });
        $.each(spots, function (ix, spot) {
            var relativeCoords = spot.coords.split(",");
            var x = Math.round(relativeCoords[0] * imageWidth) + 0.5;
            var y = Math.round(relativeCoords[1] * imageHeight) + 0.5;
            spotCoords.push({ x: x, y: y });
        });
        return spotCoords;
    },
    createImageMapsterAreaOptions: function (imageMapData) {
        var imageMapsterAreaOptions = [];
        var spots = $.grep(imageMapData.areas, function (area) {
            return area.type == "spot";
        });
        $.each(spots, function (ix, spot) {
            imageMapsterAreaOptions.push({
                key: imageMapData.id + "-" + spot.index,
                fill: false,
                stroke: false,
                render_highlight: {
                    fill: false,
                    stroke: false
                }
            });
        });
        return imageMapsterAreaOptions;
    },
    getImageMapIdFromArea: function (area) {
        var imageMapId = area.key.split("-")[0];
        return imageMapId;
    },
    getAreaIndexFromArea: function (area) {
        var areaIndex = area.key.split("-")[1];
        return areaIndex;
    },
    createAreasFromData: function (id, imageWidth, imageHeight, spotSize) {
        var areas = InRiverImageMap._imageMapOptions[id].imageMapData.areas;
        var mapEl = $("map[name^=map-" + id + "]");
        mapEl.empty();

        $.each(areas, function (ix, area) {
            var absoluteCoords = "";
            var shape = null;

            // Transform relative coordinates
            var relativeCoords = area.coords.split(",");
            for (var i = 0; i < relativeCoords.length; i += 2) {
                absoluteCoords += Math.round(relativeCoords[i] * imageWidth) + ",";
                absoluteCoords += Math.round(relativeCoords[i + 1] * imageHeight) + ",";
            }
            absoluteCoords = absoluteCoords.substring(0, absoluteCoords.length - 1); // remove last comma

            // Special treatment for spots (they will become imagemap circles)
            if (area.type == "spot") {
                absoluteCoords += "," + (Math.round(spotSize)); // radius 
                shape = "circle";
            } else {
                shape = area.type;
            }

            // Create area element
            var areaEl = $("<area/>", {
                key: id + "-" + ix,
                shape: shape,
                coords: absoluteCoords,
                href: "#"
            });
            mapEl.append(areaEl);
        });
    },
    highlightAllAreas: function (id) {
        $("area[key^=" + id + "-]").each(function () {
            $(this).mapster("highlight");
        });
    },
    removeHighlightFromAllAreas: function (id) {
        $("img[inriver-id=" + id + "]").mapster("highlight", false);
    },
    highlightArea: function (id, index) {
        $("area[key=" + id + "-" + index + "]").mapster("highlight");
    },
}

